import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const WORKS = [
  {
    title: "Residential Design & Visualization",
    tag: "Architecture / Exterior Viz",
    img: "/works/villa-exterior.jpg",
    span: "md:col-span-7 md:row-span-2",
  },
  {
    title: "Private Villa — Night Study",
    tag: "Exterior Render",
    img: "/works/villa-night.jpg",
    span: "md:col-span-5",
  },
  {
    title: "Interior Suites",
    tag: "Interior Visualization",
    img: "/works/interior-suite.jpg",
    span: "md:col-span-5",
  },
  {
    title: "Indoor Fish Farm & Aquaponics — Dubai",
    tag: "BIM Master Planning / International",
    img: "/works/aquaponics-bim.jpg",
    span: "md:col-span-12",
  },
];

export default function Portfolio() {
  return (
    <section id="work" className="py-28 lg:py-36 border-b border-white/10" data-testid="portfolio-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between mb-16 flex-wrap gap-6">
          <div>
            <motion.p initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7 }} className="font-mono-tech text-xs tracking-[0.35em] uppercase text-neutral-500 mb-4">
              04 / Work
            </motion.p>
            <motion.h2 initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }} className="font-heading font-bold uppercase tracking-tighter text-3xl sm:text-4xl lg:text-5xl">
              Selected visions
            </motion.h2>
          </div>
          <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.2 }} className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-neutral-600">
            From the studio archive — full portfolio on request
          </motion.p>
        </div>

        <div className="grid md:grid-cols-12 gap-4 auto-rows-[16rem] md:auto-rows-[15rem]">
          {WORKS.map((w, i) => (
            <motion.div
              key={w.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className={`group relative overflow-hidden border border-white/10 ${w.span}`}
              data-testid={`work-item-${i}`}
            >
              <img
                src={w.img}
                alt={w.title}
                className="absolute inset-0 w-full h-full object-cover grayscale opacity-60 group-hover:opacity-90 group-hover:scale-105 transition-[opacity,transform] duration-700 ease-out"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6 flex items-end justify-between">
                <div>
                  <p className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-neutral-400 mb-1.5">{w.tag}</p>
                  <h3 className="font-heading font-bold uppercase tracking-tight text-lg lg:text-xl group-hover:translate-x-1 transition-transform duration-300">
                    {w.title}
                  </h3>
                </div>
                <ArrowUpRight size={20} className="text-white/0 group-hover:text-white transition-colors duration-300 mb-1" />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
